import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./reducers";
import type { RootState } from "./reducers";
import { persistStore } from "redux-persist";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";

// Ф4а задача 6: слайсы user/city/brand/point снесены — их persist-записи
// осиротели. employee включён на всякий случай: его persistReducer был
// объявлен, но в combineReducers не подключён, поэтому ключа, скорее всего,
// и не было. menu и category не персистились никогда, вопреки тому, что
// утверждает CLAUDE.md подмодуля.
//
// Гард на window — не перестраховка: этот файл уже проверяет его ниже, и
// ts-jest гоняет часть сюит в среде без localStorage. Без него импорт стора
// падал бы ReferenceError, а не тестом.
const ORPHANED_PERSIST_KEYS = [
  "persist:user",
  "persist:city",
  "persist:brand",
  "persist:point",
  "persist:employee",
];
if (typeof window !== "undefined") {
  for (const key of ORPHANED_PERSIST_KEYS) {
    window.localStorage.removeItem(key);
  }
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type { RootState };

// Typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
